module.exports = __webpack_public_path__ + "img/pig.a2da3847.svg";